import React from 'react';
import { Section } from './ui/Section';
import { Countdown } from './ui/Countdown';
export function Pricing({
  id
}: {
  id?: string;
}) {
  return <Section id={id} variant="alt" data-id="element-164">
      <div className="text-center mb-10" data-id="element-165">
        <h2 className="font-display text-2xl md:text-3xl font-bold text-brand-cta mb-6" data-id="element-166">
          ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
        </h2>
        <Countdown data-id="element-167" />

        <div className="max-w-md mx-auto mt-8 bg-white border border-neutral-200 rounded-full p-1 shadow-sm" data-id="element-168">
          <div className="flex items-center justify-between px-4 py-2 text-sm font-medium" data-id="element-169">
            <span className="font-body text-red-500 flex items-center gap-2" data-id="element-170">
              <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-171"></span>{' '}
              Cupos al precio de lanzamiento
            </span>
            <span className="font-heading text-brand-cta font-bold" data-id="element-172">
              71% tomados
            </span>
          </div>
          <div className="w-full bg-neutral-100 rounded-full h-2 mt-1 mx-2 w-[calc(100%-1rem)] overflow-hidden" data-id="element-173">
            <div className="bg-gradient-to-r from-red-400 to-brand-cta h-2 rounded-full" style={{
            width: '71%'
          }} data-id="element-174"></div>
          </div>
        </div>
      </div>

      <h3 className="font-display text-3xl md:text-4xl font-bold text-center mb-10 text-brand-title" data-id="element-175">
        💳 ELIGE TU AUDITOR
      </h3>

      <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-176">
        {/* Base Offer */}
        <div className="bg-white border border-neutral-200 rounded-3xl p-8 flex flex-col shadow-sm" data-id="element-177">
          <div className="font-heading text-xl font-bold mb-2 text-brand-title" data-id="element-178">
            📘 OFERTA BASE — LA TRANSFORMACIÓN COMPLETA
          </div>
          <div className="font-body text-brand-subtitle text-sm mb-6 pb-6 border-b border-neutral-100 font-medium" data-id="element-179">
            5 Tomos + 3 Bonos estratégicos
            <br data-id="element-180" />
            <span className="text-brand-text mt-4 block leading-relaxed" data-id="element-181">
              Todo lo que necesitas para auditar tu piel, reparar tu barrera
              cutánea y construir la rutina que te dará resultados reales de por
              vida.
            </span>
          </div>

          <div className="mb-8 flex-grow" data-id="element-182">
            <div className="font-body text-neutral-400 text-sm mb-1" data-id="element-183">
              Valor real: 69.99€
            </div>
            <div className="flex items-end gap-3 mb-2" data-id="element-184">
              <span className="font-heading text-5xl font-black text-brand-title" data-id="element-185">
                13.99€
              </span>
            </div>
          </div>

          <a href="https://pagos.digipromarket.com/cart/56484209328454:1" target="_blank" rel="noopener noreferrer" className="font-heading w-full bg-brand-cta hover:bg-brand-ctaHover text-white font-bold text-lg py-4 px-6 rounded-xl transition-transform hover:scale-[1.02] active:scale-[0.98] text-center block shadow-md" data-id="element-186">
            → QUIERO MI AUDITOR DE SKINCARE™
          </a>
        </div>

        {/* Complete Offer */}
        <div className="bg-white border-2 border-brand-gold rounded-3xl p-8 flex flex-col relative shadow-[0_10px_40px_rgba(201,168,76,0.15)] transform md:-translate-y-4" data-id="element-187">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-gold text-white font-heading font-bold px-4 py-1 rounded-full text-sm whitespace-nowrap shadow-sm" data-id="element-188">
            ⭐ LA MÁS ELEGIDA
          </div>

          <div className="font-heading text-xl font-bold mb-2 text-brand-title" data-id="element-189">
            🏆 OFERTA COMPLETA — PIEL SIN FILTROS™
          </div>
          <div className="font-body text-brand-subtitle text-sm mb-6 pb-6 border-b border-neutral-100 font-medium" data-id="element-190">
            5 Tomos + 3 Bonos + Sistema de Alta Potencia
            <br data-id="element-191" />
            <span className="text-brand-text mt-4 block leading-relaxed" data-id="element-192">
              Para las mujeres que no quieren solo mejorar su piel. Quieren
              transformarla por completo.
            </span>
          </div>

          <div className="mb-8 flex-grow" data-id="element-193">
            <div className="font-body text-neutral-400 text-sm mb-1" data-id="element-194">
              Valor real: 97.99€
            </div>
            <div className="flex items-end gap-3 mb-2" data-id="element-195">
              <span className="font-heading text-5xl font-black text-brand-title" data-id="element-196">
                19.99€
              </span>
            </div>
          </div>

          <a href="https://pagos.digipromarket.com/cart/56484211622214:1" target="_blank" rel="noopener noreferrer" className="font-heading w-full bg-brand-cta hover:bg-brand-ctaHover text-white font-bold text-lg py-4 px-6 rounded-xl transition-transform hover:scale-[1.02] active:scale-[0.98] shadow-[0_10px_30px_rgba(123,47,190,0.3)] text-center block" data-id="element-197">
            → SÍ, QUIERO PIEL SIN FILTROS™ + EL AUDITOR COMPLETO
          </a>
        </div>
      </div>
    </Section>;
}